import { Button, Modal } from "antd";
import React from "react";
import { FormWrapperSC } from "./styled";

interface ConfirmModalProps {
  text: string;
  onOk: () => void;
  onCancel: () => void;
  open: boolean;
  title: string;
  body?: React.ReactNode;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  text,
  onOk,
  onCancel,
  open,
  body,
  title,
}) => {
  return (
    <Modal
      open={open}
      title={title}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          cancel
        </Button>,
        <Button key="submit" type="primary" onClick={onOk}>
          OK
        </Button>,
      ]}
    >
      <FormWrapperSC>
        {text}
        {body}
      </FormWrapperSC>
    </Modal>
  );
};
